/*
自作のスクリプトはここに
 */

export const app = () => {
  const windowStatus = () => {
    const body = document.body

    let currentOffset = 0
    let isDown = false
    let isTop = window.pageYOffset == 0 ? false : true
    let isPosition = ''

    const scroll = () => {
      const pageYOffset = window.pageYOffset
      const bodyHeight = body.clientHeight
      const innerHeight = window.innerHeight

      if (isPosition == 'top' && pageYOffset > 0) {
        if (pageYOffset + innerHeight < bodyHeight) {
          isPosition = 'middle'
          body.classList.add('is-middle')
        } else {
          isPosition = 'bottom'
          body.classList.add('is-bottom')
        }
        body.classList.remove('is-top')
      } else if (isPosition == 'middle' && (pageYOffset <= 0 || pageYOffset + innerHeight >= bodyHeight)) {
        if (pageYOffset <= 0) {
          isPosition = 'top'
          body.classList.add('is-top')
        } else {
          isPosition = 'bottom'
          body.classList.add('is-bottom')
        }
        body.classList.remove('is-middle')
      } else if (isPosition == 'bottom' && pageYOffset + innerHeight < bodyHeight) {
        if (pageYOffset <= 0) {
          isPosition = 'top'
          body.classList.add('is-top')
        } else {
          isPosition = 'middle'
          body.classList.add('is-middle')
        }
        body.classList.remove('is-bottom')
      } else {
        if (pageYOffset <= 0) {
          isPosition = 'top'
          body.classList.add('is-top')
        } else if (pageYOffset + innerHeight < bodyHeight) {
          isPosition = 'middle'
          body.classList.add('is-middle')
        } else {
          isPosition = 'bottom'
          body.classList.add('is-bottom')
        }
      }

      if (isDown) {
        if (pageYOffset > 100 && pageYOffset > currentOffset) {
          isDown = false
          body.classList.add('is-down')
          body.classList.remove('is-up')
        }
      } else {
        if (pageYOffset <= currentOffset) {
          isDown = true
          body.classList.remove('is-down')
          body.classList.add('is-up')
        }
      }
      if (isTop) {
        if (pageYOffset > 0) {
          isTop = false
          body.classList.remove('is-top')
        }
      } else {
        if (pageYOffset <= 0) {
          isTop = true
          body.classList.add('is-top')
          body.classList.remove('not-top')
        }
      }

      currentOffset = pageYOffset
    }

    const orientationQuery = window.matchMedia('(orientation: landscape)')

    const mediaChange = function (e) {
      if (e.matches) {
        body.classList.remove('is-vertical')
        body.classList.add('is-horizontal')
      } else {
        body.classList.remove('is-horizontal')
        body.classList.add('is-vertical')
      }
    }

    orientationQuery.addListener(mediaChange)

    scroll()
    mediaChange(orientationQuery)

    window.addEventListener('load', scroll)
    window.addEventListener('scroll', scroll)
    window.addEventListener('resize', scroll)

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        scroll()
        mediaChange(orientationQuery)
      }, 50)
    })
  }

  // const opening = () => {
  //   if (document.querySelector('.js-kv') == null) return
  //   const $kv = $('.js-kv')
  //   const $video = $('.js-kv_video')[0]
  //   $(window)
  //     .delay(500)
  //     .queue(function () {
  //       $kv.addClass('is-loaded')
  //       $video.play()
  //     })
  // }

  const textSplit = () => {
    let setElm = $('.js-split'),
      className = 'n'
    setElm
      .children()
      .addBack()
      .contents()
      .each(function () {
        let elmThis = $(this)
        if (this.nodeType == 3) {
          let $this = $(this)
          $this.replaceWith($this.text().replace(/(\S)/g, '<span>$&</span>'))
        }
        setElm.each(function () {
          $(this)
            .find('span')
            .each(function (i) {
              i = i + 1
              $(this).addClass(className + i)
            })
        })
      })
  }

  const slick = () => {
    // $('.js-slick_bnr').slick({
    //   infinite: true,
    //   slidesToShow: 3,
    //   arrows: false,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // })
    // $('.js-slick_pickup').slick({
    //   infinite: false,
    //   slidesToShow: 3,
    //   dots: true,
    //   appendArrows: $('.js-add_controller .arrow'),
    //   appendDots: $('.js-add_controller'),
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         infinite: true,
    //         slidesToShow: 1,
    //         arrows: false,
    //       },
    //     },
    //   ],
    // })
    let hoge = $('.slick-dots').width()
    $('.js-add_controller .arrow').width(hoge + 110)
    $('.js-slick_event').slick({
      infinite: false,
      dots: true,
      slidesToShow: 3,
      appendArrows: $('.js-add_arrow'),
      appendDots: $('.js-add_dots'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    })
    if (window.matchMedia('(min-width:767px)').matches) {
      $('.js-slick_event1').slick({
        infinite: false,
        dots: true,
        slidesToShow: 3,
        appendArrows: $('.js-add_arrow1'),
        appendDots: $('.js-add_dots1'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              // arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      })
      $('.js-slick_event2').slick({
        infinite: false,
        dots: true,
        slidesToShow: 3,
        appendArrows: $('.js-add_arrow2'),
        appendDots: $('.js-add_dots2'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              // arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      })
      $('.js-slick_event3').slick({
        infinite: false,
        dots: true,
        slidesToShow: 3,
        appendArrows: $('.js-add_arrow3'),
        appendDots: $('.js-add_dots3'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              // arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      })
    }
    $('.js-slick_event_bnr').slick({
      infinite: false,
      dots: true,
      slidesToShow: 2,
      appendArrows: $('.js-add_controller .arrow'),
      appendDots: $('.js-add_controller'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            slidesToShow: 1,
          },
        },
      ],
    })
    let hoge2 = $('.js-add_controller .slick-dots').width()
    $('.js-add_controller .arrow').width(hoge2 + 110)

    let projectslider = $('.js-slick_project')
    projectslider.slick({
      infinite: true,
      slidesToShow: 1,
      // arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    })
    $('.js-accordion').on('click', (event) => {
      projectslider.slick('setPosition')
    })

    // $('.js-slick_instructor').slick({
    //   infinite: true,
    //   slidesToShow: 4,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         arrows: false,
    //         rows: 2,
    //       },
    //     },
    //   ],
    // })
    // $('.js-slick_instructorS').slick({
    //   infinite: true,
    //   slidesToShow: 3,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         arrows: false,
    //       },
    //     },
    //   ],
    // })
    // $('.js-slick_movie').slick({
    //   infinite: true,
    //   // dots: true,
    //   slidesToShow: 1.3,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //         arrows: false,
    //       },
    //     },
    //   ],
    // })
    // $('.js-slick_interview').slick({
    //   infinite: true,
    //   dots: false,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //       },
    //     },
    //   ],
    // })
    let slideLists = []
    for (let i = 0; i < 10; i++) {
      slideLists[i] = '.js-slick_floor' + [i]
    }
    for (let slideList of slideLists) {
      let slideElm = $(slideList)
      $(slideElm).slick({
        dots: true,
        arrows: true,
        fade: true,
        speed: 500,
      })
    }
  }

  const drawer = () => {
    $('#js-hamburger').on('click', (event) => {
      let $this = $(event.currentTarget)
      $this.toggleClass('is-act')
      $('html').toggleClass('is-fixed')
      $('#js-drawer').stop(true, true).fadeToggle(200)
      $('.js-fixed').toggleClass('is-fixed')
      $('#js-header').toggleClass('is-open')
    })

    const $megaArr = $('.js-mega')
    $megaArr.each((i, elm) => {
      const $trg = $(elm).find('.js-mega_trg')
      const $content = $(elm).find('.js-mega_content')
      $trg.on('click', (event) => {
        event.preventDefault()
        $content.stop(true, true).slideToggle(400)
        $(elm).toggleClass('is-act')
      })
    })
  }

  const accordion = () => {
    $('.js-accordion')
      .find('.js-trg')
      .on('click', (event) => {
        let $this = $(event.currentTarget)
        $this.next().stop(true, true).slideToggle(400)
        $this.toggleClass('is-act')
        if ($this.hasClass('hide')) {
          $this.fadeOut()
        }
      })
  }

  const commonAccordion = () => {
    const $htmlBody = $('html, body')
    if (document.querySelector('.l-header__logo') == null) return
    const header = document.querySelector('.l-header__logo')
    $('.js-common-accordion').each(function () {
      const $this = $(this)
      if ($this.find('.js-common-accordion-container').length == 0 || $this.find('.js-common-accordion-inner').length == 0 || $this.find('.js-common-accordion-button').length == 0) return
      const $inner = $this.find('.js-common-accordion-inner')
      const $container = $this.find('.js-common-accordion-container')
      const $button = $this.find('.js-common-accordion-button')
      let isAct = false
      $container.css({ overflow: 'hidden', height: 0 })
      $button.on('click', function () {
        if (isAct) {
          isAct = false
          $container.css({ height: $inner.height() + 'px' })
          $container.stop().animate({ height: 0 })
          $this.removeClass('is-open')
          $button.removeClass('is-open')
          $htmlBody.stop().animate({ scrollTop: $container.offset().top - header.clientHeight })
        } else {
          isAct = true
          $this.addClass('is-open')
          $button.addClass('is-open')
          $container.stop().animate({ height: $inner.height() + 'px' }, function () {
            $container.css({ height: 'auto' })
          })
        }
      })
    })
  }

  const tab = () => {
    if (document.getElementsByClassName('js-tab_trg').length > 0) {
      var $parents = $('.js-tab_trg').parent()
      $parents.each(function () {
        var $parent = $(this)
        var $jsTabTrg = $parent.find('.js-tab_trg').eq(0)
        var $jsTabArea = $parent.find('.js-tab_area').eq(0)
        if ($jsTabArea) {
          var $jsTabTrgLi = $jsTabTrg.find('li')
          $jsTabTrgLi.on('click', (event) => {
            let $this = $(event.currentTarget)
            let index = $jsTabTrgLi.index($this)
            var jsTabBody = $jsTabArea.find('.js-tab_body')
            $jsTabTrgLi.removeClass('is-act')
            jsTabBody.hide()
            $this.addClass('is-act')
            jsTabBody.eq(index).fadeIn('fast')
            if (window.matchMedia('(min-width:767px)').matches) {
              // タブ内の高さ取得
              $('.p-admissions_document').find('.js-tile').tile(2)
              $('.p-instructor').find('.js-tile').tile(3)
            }
          })
        }
      })
    }
  }

  const archive_narrow = () => {
    $('.js-drop')
      .find('.js-trg')
      .on('click', (event) => {
        let $this = $(event.currentTarget)
        $this.children().stop(true, true).slideToggle(400)
      })
  }

  const scheduleShow = () => {
    $('.js-opencampus_date')
      .find('.js-opencampus_date_more')
      .on('click', (event) => {
        let $this = $(event.currentTarget)
        $('.js-opencampus_date_table').find('dl').toggleClass('is-act')
        $this.toggleClass('is-act')
      })
  }

  // const moreShow = () => {
  //   $('.js-more_trg').on('click', (event) => {
  //     let $this = $(event.currentTarget)
  //     $this.parent('.js-more_content').toggleClass('is-open')
  //     $this.toggleClass('is-open')
  //   })
  // }

  const modalAddClass = () => {
    $('.js-modal.-wide').on('click', (event) => {
      $('.modaal-container').addClass('-wide')
    })
  }

  const modalClose = () => {
    $('.js-modal_close').on('click', (event) => {
      $('.js-modal').modaal('close')
    })
  }

  const worldCardAccordion = () => {
    const button = $('.js-card_aco_button')
    button.each(function () {
      const self = $(this)
      const trg = self.find('span')
      const content = self.prev('.js-card_aco_content')

      trg.on('click', (event) => {
        let $this = $(event.currentTarget)

        $this.toggleClass('is-open')
        content.toggleClass('is-open')

        if (content.hasClass('is-open')) {
          // content.stop(true, true).height("auto");
          self.addClass('is-hide')
          gsap.to(content, {
            height: 'auto',
            overflow: 'visible',
            onComplete: function () {
              self.removeClass('is-hide')
            },
          })
        } else {
          gsap.to(content, {
            height: '180px',
            overflow: 'hidden',
          })
          // content.stop(true, true).height("180px");
        }
      })
    })
  }

  const worldModal = () => {
    const $block = $('.js-world_modal')
    $block.each(function () {
      const self = $(this)
      const trg = self.find('.js-world_modal_trg')
      const content = self.find('.js-world_modal_content')
      const close = self.find('.js-world_modal_close')
      const overlay = self.find('.js-world_modal_overlay')

      trg.on('click', (event) => {
        $('html').toggleClass('is-fixed')
        gsap.to(content, {
          autoAlpha: 1,
          display: 'block',
        })
      })
      close.on('click', (event) => {
        $('html').toggleClass('is-fixed')
        gsap.to(content, {
          autoAlpha: 0,
          display: 'none',
        })
      })
      overlay.on('click', (event) => {
        $('html').toggleClass('is-fixed')
        gsap.to(content, {
          autoAlpha: 0,
          display: 'none',
        })
      })
    })
  }

  const worldGallerySlider = () => {
    const swiper = new Swiper('.js-world_gallery_slider', {
      autoplay: {
        delay: 0,
      },
      // direction: "horizontal",
      // loopPreventsSlide: false,
      slidesPerView: 1.5,
      loop: true,
      speed: 10000,
      freeMode: true,
      allowTouchMove: false,
      breakpoints: {
        768: {
          slidesPerView: 3.5,
        },
      },
    })
  }

  const worldVideoSlider = () => {
    // window.addEventListener('load', () => {})
    const slider = $('.js-world_video_slider')
    slider.each(function () {
      const self = $(this)
      const slide = self.find('.swiper-slide')
      const slideLength = slide.length

      let sliderOption = {
        loop: true,
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 20,
        speed: 800,
        grabCursor: true,
        touchEventsTarget: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      }

      if (slideLength == 1) {
        sliderOption = {
          loop: false,
          slidesPerView: 1.1,
          centeredSlides: true,
          spaceBetween: 20,
          speed: 800,
          touchEventsTarget: true,
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
          },
        }
      }

      const swiper = new Swiper(self, sliderOption)
    })
  }
  const worldVoiceSlider = () => {
    const swiper = new Swiper('.js-world_voice_slider', {
      autoplay: {
        delay: 0,
      },
      // direction: "horizontal",
      // loopPreventsSlide: false,
      slidesPerView: 2,
      loop: true,
      speed: 10000,
      freeMode: true,
      allowTouchMove: false,
      breakpoints: {
        768: {
          slidesPerView: 5,
        },
      },
    })
  }
  const worldPoint03Slider = () => {
    const swiper = new Swiper('.js-world_point03_slider', {
      autoplay: {
        delay: 0,
      },
      // direction: "horizontal",
      // loopPreventsSlide: false,
      slidesPerView: 1.25,
      loop: true,
      speed: 10000,
      freeMode: true,
      allowTouchMove: false,
      //spaceBetween: 10,
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 2.5,
        },
      },
    })
  }
  const worldOtherProjectAco = () => {
    window.addEventListener('load', () => {
      if (document.getElementsByClassName('js-world-other-project-aco').length == 0) return
      if (document.querySelector('.l-header__logo') == null) return
      const $accordion = $('.js-world-other-project-aco')
      const $htmlBody = $('html, body')
      const header = document.querySelector('.l-header__logo')
      $accordion.each(function () {
        const $this = $(this)
        const appearance = $this.attr('data-appearance') - 0
        let isOpen = false
        if ($this.find('.js-world-other-project-aco-button span').length == 0) return
        if ($this.find('.js-world-other-project-aco-list').length == 0) return
        const $button = $this.find('.js-world-other-project-aco-button span').eq(0)
        const $list = $this.find('.js-world-other-project-aco-list').eq(0)
        if ($list.children().length <= 3) {
          $button.parent().remove()
          return
        }
        $list.wrap('<div></div>')
        const $container = $list.parent()
        $container.addClass('js-world-other-project-aco-container')
        const $children = $list.children()
        let maxHeight = 0
        const resize = () => {
          if (appearance) {
            maxHeight = $children.eq(0).height() * appearance
          } else {
            maxHeight = $children.eq(0).height() * 1.5
          }
        }
        resize()
        window.addEventListener('resize', resize)
        $container.css({ overflow: 'hidden', height: maxHeight + 'px' })
        $button.on('click', function () {
          if (isOpen) {
            isOpen = false
            $this.removeClass('is-open')
            $button.removeClass('is-open')
            $container.stop().animate({ height: maxHeight + 'px' })
            $htmlBody.stop().animate({ scrollTop: $container.offset().top - header.clientHeight })
          } else {
            isOpen = true
            $this.addClass('is-open')
            $button.addClass('is-open')
            $container.stop().animate({ height: $list.height() + 'px' })
          }
        })
      })
    })
  }

  const world3projectSlider = () => {
    const swiper = new Swiper('.js-world_3project_slider', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 80,
      speed: 800,
      // allowTouchMove: false,
      // grabCursor: true,
      touchEventsTarget: true,
      navigation: {
        nextEl: '.js-world_3project_slider .swiper-button-next',
        prevEl: '.js-world_3project_slider .swiper-button-prev',
      },
    })
  }

  const worldPickupSlider = () => {
    if (window.innerWidth < 768) {
      $('.js-world_pickup_slider .swiper-wrapper').addClass('no-slider')
      $('.js-world_pickup_slider .swiper-wrapper').removeClass('swiper-wrapper')
      return
    }
    const swiper = new Swiper('.js-world_pickup_slider', {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 80,
      speed: 800,
      touchEventsTarget: true,
    })
  }

  const worldSpotSlider = () => {
    const slider = $('.js-world_spot_slider')
    const slide = slider.find('.swiper-slide')
    const slideLength = slide.length

    let sliderOption = {
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 20,
      speed: 800,
      grabCursor: true,
      touchEventsTarget: true,
      pagination: {
        el: '.js-world_spot_slider .swiper-pagination',
        type: 'fraction',
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
    }

    if (slideLength == 1) {
      sliderOption = {
        loop: false,
        slidesPerView: 1.1,
        centeredSlides: true,
        spaceBetween: 20,
        speed: 800,
        touchEventsTarget: true,
        pagination: {
          el: '.js-world_spot_slider .swiper-pagination',
          type: 'fraction',
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        },
      }
    }

    const swiper = new Swiper(slider, sliderOption)
  }

  // 内容の一部が見えているアコーディオン
  const accordionExpand = () => {
    const $acoArr = $('.js-aco-expand')
    $acoArr.each((i, elm) => {
      const $trg = $(elm).find('.js-aco-expand_trg')
      const $originalTrgText = $trg.find('p').text()
      const $content = $(elm).find('.js-aco-expand_content')
      const $originalContentHeight = $content.height()

      let closedHeight = '18em' //閉じた状態の高さ

      const dataHeight = $(elm).attr('data-height')
      if (dataHeight !== undefined) {
        closedHeight = dataHeight
      }

      $content.height(closedHeight)

      $trg.click(() => {
        $(elm).toggleClass('is-open')
        if ($(elm).hasClass('is-open')) {
          $trg.find('p').text('閉じる')
          $content.animate({
            height: $originalContentHeight,
          })
        } else {
          const $offset = $(elm).offset().top
          $content.animate(
            {
              height: closedHeight,
            },
            300,
          )
          $('html,body').animate(
            {
              scrollTop: $offset - $(window).height() / 3,
            },
            300,
          )
          $trg.find('p').text($originalTrgText)
        }
      })
    })
  }

  const indexPickupSlider = () => {
    const swiper = new Swiper('.js-index_pickup_slider', {
      slidesPerView: 1.4,
      spaceBetween: 20,
      grabCursor: true,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 2.4,
        },
        1300: {
          slidesPerView: 4.4,
          spaceBetween: 30,
        },
      },
    })
  }

  const opencampusPickupSlider = () => {
    const swiper = new Swiper('.js-opencampus_pickup_slider', {
      slidesPerView: 1.4,
      spaceBetween: 20,
      grabCursor: true,
      // loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
  }

  const indexOpencampusSlider = () => {
    if (document.getElementsByClassName('js-index_opencampus_slider').length == 0) return
    const slider = $('.js-index_opencampus_slider')
    const mediaQuery = window.matchMedia('(min-width:768px)') // 768px以上
    let swiper

    const initSwiper = () => {
      swiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 30,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2.2,
          },
          1300: {
            slidesPerView: 3.3,
          },
        },
      })
    }

    const checkBreakpoint = (e) => {
      if (e.matches) {
        initSwiper()
      } else {
        if (swiper) swiper.destroy(true, true)
      }
    }

    mediaQuery.addListener(checkBreakpoint) // ブレークポイント通過時に実行
    checkBreakpoint(mediaQuery) // ロード時に実行
  }

  const indexFeatureSlider = () => {
    const swiper = new Swiper('.js-index_feature_slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: '.js-index_feature_slider .swiper-button-next',
        prevEl: '.js-index_feature_slider .swiper-button-prev',
      },
      pagination: {
        el: '.js-index_feature_slider .swiper-pagination',
        type: 'progressbar', // プログレスバー
        // clickable: true, 無効化
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
      },
    })
  }

  const bnrTitle = () => {
    $(function () {
      const $bnrArr = $('.js-bnr_title')
      $bnrArr.each((i, elm) => {
        const $img = $(elm).find('img')
        const $imgTitle = $img.attr('title')
        $img.after('<p class="title">' + $imgTitle + '</p>')
      })
    })
  }

  const worldIntroSlider = () => {
    const swiper = new Swiper('.js-world_intro_slider', {
      slidesPerView: 2.2,
      spaceBetween: 20,
      grabCursor: true,
      loop: true,
      navigation: {
        nextEl: '.js-world_intro_slider .swiper-button-next',
        prevEl: '.js-world_intro_slider .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          // spaceBetween: 30,
        },
      },
    })
  }

  const worldSlider01 = () => {
    const sliderArr = $('.js-world_slider01')
    sliderArr.each((i, slider) => {
      const slide = $(slider).find('.swiper-slide')
      const slideLength = slide.length
      const viewValue = $(slider).data('view')
      const viewXsValue = $(slider).data('view-xs')
      const centerValue = $(slider).data('center')
      const loopValue = $(slider).data('loop')
      let sliderOption = {
        loop: false,
        centeredSlides: false,
        slidesPerView: 1.3,
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
        },
      }
      if (viewXsValue) {
        sliderOption.slidesPerView = viewXsValue
      }
      if (viewValue) {
        sliderOption.breakpoints[768].slidesPerView = viewValue
      }
      if (centerValue) {
        sliderOption.centeredSlides = centerValue
      }
      if (loopValue) {
        sliderOption.loop = loopValue
      }
      if (slideLength == 1) {
        sliderOption.loop = false
      }
      const swiper = new Swiper($(slider), sliderOption)
    })
  }

  const opencampusSlider01 = () => {
    const swiper = new Swiper('.js-opencampus_slider01', {
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: '.js-opencampus_slider01 .swiper-button-next',
        prevEl: '.js-opencampus_slider01 .swiper-button-prev',
      },
      pagination: {
        el: '.js-opencampus_slider01 .swiper-pagination',
        type: 'progressbar', // プログレスバー
        // clickable: true, 無効化
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
  }

  const topicsPickupSlider = () => {
    const swiper = new Swiper('.js-topics_pickup_slider', {
      slidesPerView: 1.2,
      spaceBetween: 20,
      grabCursor: true,
      breakpoints: {
        768: {
          slidesPerView: 1.6,
        },
        1300: {
          slidesPerView: 2.2,
          spaceBetween: 40,
        },
      },
    })
  }

  const copyURL = () => {
    const target = document.getElementById('copy-url')
    if (!target) return

    const addCompleteHTML = () => {
      const dataComplete = target.getAttribute('data-complete')
      const completeHTML = `<p class="complete-text">${dataComplete}</p>`
      target.insertAdjacentHTML('afterend', completeHTML)
    }

    addCompleteHTML()

    const copyToClipboard = () => {
      // テキストエリアを作成する（一時的な要素）
      const textarea = document.createElement('textarea')
      // data-urlの値を取得
      const dataUrl = target.getAttribute('data-url')
      // テキストエリアの値にdata-urlの値を設定
      textarea.value = dataUrl
      // テキストエリアをDOMに追加
      document.body.appendChild(textarea)
      // テキストエリアを選択状態にする
      textarea.select()
      // コピー操作を実行
      document.execCommand('copy')
      // テキストエリアを削除
      document.body.removeChild(textarea)
    }
    target.addEventListener('click', () => {
      copyToClipboard()
      const completeText = document.querySelector('.complete-text')
      completeText.classList.add('is-act')
      setTimeout(() => {
        completeText.classList.remove('is-act')
      }, 2000)
    })
  }

  /******/

  /*
呼び出しはここで
 */
  ;(($) => {
    $(() => {
      windowStatus()
      textSplit()
      slick()
      drawer()
      accordion()
      tab()
      archive_narrow()
      scheduleShow()
      $('.js-modal').modaal()
      // moreShow()
      modalAddClass()
      modalClose()
      worldCardAccordion()
      worldModal()
      worldGallerySlider()
      worldVoiceSlider()
      worldVideoSlider()
      world3projectSlider()
      worldSpotSlider()
      worldOtherProjectAco()
      worldPickupSlider()
      worldPoint03Slider()
      commonAccordion()
      accordionExpand()
      indexPickupSlider()
      opencampusPickupSlider()
      indexOpencampusSlider()
      indexFeatureSlider()
      // opening()
      bnrTitle()
      worldIntroSlider()
      worldSlider01()
      opencampusSlider01()
      topicsPickupSlider()
      copyURL()
    })

    $(window).on('load resize', () => {
      if (window.matchMedia('(min-width:767px)').matches) {
        $('.p-ao').find('.js-tile').tile(2)
        $('.p-study').find('.js-tile').tile(2)
        $('.p-admissions_document').find('.js-tile').tile(2)
        $('.p-dormitory').find('.js-tile').tile(2)
        $('.p-room').find('.js-tile').tile(2)
        // $('.p-instructor').find('.js-tile').tile(3);
        $('.p-super-entertainment').find('.js-tile').tile(3)
        $('.p-world_instructor').find('.js-tile').tile()
        $('.p-w-curriculum').find('.js-tile').tile(2)
        $('.p-overseas_school').find('.js-tile').tile(3)
        $('.p-overseas_program').find('.js-tile').tile(4)
        $('.p-abroad_support').find('.js-tile').tile(3)
        $('.p-abroad_voice').find('.js-tile').tile(2)
        $('.p-corona_archive').find('.js-tile').tile()
        $('.p-scholarship_plan__list').find('.js-tile').tile(3)
        $('.p-scholarship_knowledge').find('.js-tile').tile(2)
      } else {
        $('.p-super-entertainment').find('.js-tile').tile(2)
        $('.p-overseas_school').find('.js-tile').tile(2)
        $('.p-overseas_program').find('.js-tile').tile(2)
      }
    })
  })(jQuery)

  /******/
}
